// extracted by mini-css-extract-plugin
export default {"betweenContainer":"h7y4ddg03XEPVKODB_fd"};